module.exports = __webpack_public_path__ + "static/media/DataIntegration.ed3263cf.svg";